<template>
  <div class="qw-qrcode">
    <vue-canvas-poster
      v-if="posterloading"
      :painting="posterPainting"
      @success="drawSuccess"
      @fail="drawFail"
    >
    </vue-canvas-poster>
    <van-skeleton title :row="3" v-if="!firstloading" />
    <div class="qrcode-box" v-else>
      <div class="qrcode-container">
        <swiper
          :options="swiperOption"
          class="swiper-wrap"
          ref="mySwiper"
          v-if="qrcodes.length != 0"
        >
          <swiper-slide
            v-for="(item, index) in qrcodes"
            :key="index"
            :name="'item' + index"
          >
            <img :src="item" alt="" />
          </swiper-slide>

          <!-- 常见的小圆点 -->
          <div
            class="swiper-pagination"
            v-for="(item, index) in qrcodes"
            :key="index"
            slot="pagination"
          ></div>
        </swiper>
      </div>
      <div class="download-desc">
        长按或鼠标右键下载图片
      </div>
      <van-button
        icon="wap-home"
        type="primary"
        class="btn-return"
        @click="back"
        >返回</van-button
      >
      <van-button icon="edit" type="info" class="btn-return" @click="edit"
        >编辑</van-button
      >
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Button, Toast } from "vant";
Vue.use(Button);
Vue.use(Toast);

import { vueCanvasPoster } from "vue-canvas-poster";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "qw-qrcode",
  data() {
    return {
      firstloading: false,
      qrcode: {
        qrcode_url: "",
      },

      qrcodes: [],
      posterloading: false,
      posterPainting: {},
      posterParams: {
        //二维码地址
        qrcode: "",
        //头像地址
        headimgurl: "",
        //昵称
        nickname: "增长女黑客",
        //公司 职位
        userdesc: "我辈科技 CEO",
        channelid:0,
        channeltype:0,
      },

      swiperOption: {
        //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        //循环
        loop: false,
        //设定初始化时slide的索引
        initialSlide: 0,
        //滑动速度
        speed: 800,
        //滑动方向
        direction: "horizontal",
        //小手掌抓取滑动
        grabCursor: true,
        on: {
          //滑动之后回调函数
          slideChangeTransitionStart: function() {
            /* realIndex为滚动到当前的slide索引值 */
            this.imgIndex = this.realIndex - 1;
          },
        },
        //分页器设置
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets",
        },
      },
    };
  },
  methods: {
    edit() {
      var t = this;
      if (t.posterParams.channeltype == 2)
        t.$router.replace({
          path: "/groupdetail",
          query: { id: t.posterParams.channelid },
        });
      else
        t.$router.replace({
          path: "/disdetail",
          query: { id: t.posterParams.channelid, type:t.posterParams.channeltype },
        });
    },
    //绘制完成
    drawSuccess(src) {
      var t = this;
      t.qrcode.qrcode_url = src;
      t.qrcodes = [t.qrcode.qrcode_url, t.posterParams.qrcode];
      t.firstloading = true;
    },
    drawFail(err) {
      Toast("网络不太给力，稍等一会再试吧");
      setTimeout(() => {
          t.$router.back(-1);
      }, 2000);
      console.log("drawFail", err);
    },
    //设置海报参数
    reloadPoster() {
      var t = this;
      var bilv = 1;
      t.posterPainting = {
        width: 750 * bilv,
        height: 975 * bilv,
        views: [
          {
            type: "rect",
            top: 0,
            left: 0,
            background: "#fff",
            width: 750 * bilv,
            height: 975 * bilv,
          },
          {
            type: "image",
            url: /url=[\w\W]+/.test(t.posterParams.headimgurl)
              ? t.posterParams.headimgurl
              : require("../../static/images/user-noicon.png"),
            left: 42 * bilv,
            top: 42 * bilv,
            width: 130 * bilv,
            height: 130 * bilv,
            radius: 10 * bilv,
          },
          {
            type: "text",
            content: t.posterParams.nickname,
            fontSize: 34 * bilv,
            bolder: true,
            top: 62 * bilv,
            left: 190 * bilv,
            width: 490 * bilv,
            breakWord: false,
            MaxLineNumber: 1,
          },
          {
            type: "text",
            content: t.posterParams.userdesc,
            color: "#666666",
            fontSize: 26 * bilv,
            bolder: false,
            top: 122 * bilv,
            left: 190 * bilv,
            width: 490 * bilv,
            breakWord: false,
            MaxLineNumber: 1,
          },
          {
            type: "image",
            url: t.posterParams.qrcode,
            left: 42 * bilv,
            top: 224 * bilv,
            width: 660 * bilv,
            height: 660 * bilv,
            radius: 0,
          },

          {
            type: "text",
            content: "扫一扫上面的二维码图案，加我的企业微信",
            color: "#666666",
            fontSize: 26 * bilv,
            bolder: false,
            top: 898 * bilv,
            textAlign: "center",
            left: 375 * bilv,
            width: 660 * bilv,
            breakWord: false,
            MaxLineNumber: 1,
          },
        ],
      };
      console.log(" t.posterPainting", t.posterPainting);
      t.posterloading = true;
    },
    //返回首页
    back() {
      window.location.href = "./";
    },
    //获得渠道对应的二维码
    getQrcode(id) {
      var t = this;
      t.$http
        .get("/Channel/GetChannelPosterNodes", { channelid: id }, 2)
        .then((res) => {
          if (res.resultState == 1) {
            t.posterParams = res.Data;
            // t.posterParams.qrcode = res.Data.qrcode_url;
            t.reloadPoster();
          } else {
            Toast(res.errorMsg);
            setTimeout(() => {
              t.$router.back(-1);
            }, 2000);
          }
        })
        .catch((error) => {
          Toast("网络异常，请刷新后重试");
        });
    },
  },
  components: {
    vueCanvasPoster,
    Swiper,
    SwiperSlide,
  },
  computed: {},
  created() {
    var t = this;
    if (t.$route.query.id) {
      t.getQrcode(t.$route.query.id);
    } else {
      Toast("错误的渠道ID");
      setTimeout(() => {
        t.$router.back(-1);
      }, 2000);
    }
  },
  mounted() {},
};
</script>

<style scoped lang="scss" src="../../static/scss/qrcode.scss"></style>
<!-- Add "scoped" attribute to limit CSS to this component only <style scoped  lang="scss" src="../../static/scss/shareindex.scss"></style>-->
